module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "notifications"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pages_maincontent"
    }
  }, [_c('a', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRequestActive),
      expression: "isRequestActive"
    }],
    staticClass: "loader"
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page_title"
  }, [_vm._v("NOTIFICATIONS")]), _vm._v(" "), _c('div', {
    staticClass: "page_single layout_fullwidth_padding"
  }, [_c('div', {
    staticClass: "contactform"
  }, [_c('label', [_vm._v("Notify Me When...")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("I get a message from " + _vm._s(_vm.salesPersonFullName))]), _vm._v(" "), _c('div', {
    staticClass: "form_row_right"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyMessageSms),
      expression: "model.companyMessageSms"
    }],
    attrs: {
      "type": "checkbox",
      "name": "message-checkbox",
      "disabled": !_vm.customerUser.mobilePhone
    },
    domProps: {
      "checked": _vm.model.companyMessageSms,
      "checked": Array.isArray(_vm.model.companyMessageSms) ? _vm._i(_vm.model.companyMessageSms, null) > -1 : (_vm.model.companyMessageSms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.companyMessageSms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "companyMessageSms", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "companyMessageSms", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "companyMessageSms", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox",
    class: {
      'disabled': !_vm.customerUser.mobilePhone
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    class: {
      'disabled': !_vm.customerUser.mobilePhone
    }
  }, [_vm._v("SMS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("The person that I sent \"Share My App\" registers their app")]), _vm._v(" "), _c('div', {
    staticClass: "form_row_right"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sharedAppSms),
      expression: "model.sharedAppSms"
    }],
    attrs: {
      "type": "checkbox",
      "name": "share-checkbox",
      "disabled": !_vm.customerUser.mobilePhone
    },
    domProps: {
      "checked": _vm.model.sharedAppSms,
      "checked": Array.isArray(_vm.model.sharedAppSms) ? _vm._i(_vm.model.sharedAppSms, null) > -1 : (_vm.model.sharedAppSms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.sharedAppSms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "sharedAppSms", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "sharedAppSms", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "sharedAppSms", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon  icon-form-checkbox",
    class: {
      'disabled': !_vm.customerUser.mobilePhone
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    class: {
      'disabled': !_vm.customerUser.mobilePhone
    }
  }, [_vm._v("SMS")])])]), _vm._v(" "), _c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sharedAppEmail),
      expression: "model.sharedAppEmail"
    }],
    attrs: {
      "type": "checkbox",
      "name": "share-checkbox",
      "disabled": !_vm.customerUser.email
    },
    domProps: {
      "checked": _vm.model.sharedAppEmail,
      "checked": Array.isArray(_vm.model.sharedAppEmail) ? _vm._i(_vm.model.sharedAppEmail, null) > -1 : (_vm.model.sharedAppEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.sharedAppEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "sharedAppEmail", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "sharedAppEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "sharedAppEmail", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox",
    class: {
      'disabled': !_vm.customerUser.email
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    class: {
      'disabled': !_vm.customerUser.email
    }
  }, [_vm._v("Email")])])])])]), _vm._v(" "), (!_vm.saveRequest.isActive) ? _c('input', {
    staticClass: "form_submit",
    style: (_vm.borderStyle),
    attrs: {
      "type": "button",
      "value": "SAVE"
    },
    on: {
      "click": _vm.submit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveRequest.isActive) ? _c('div', {
    staticClass: "loader"
  }, [(!_vm.saveRequest.isSuccess) ? _c('looping-rhombuses-spinner', {
    style: ({
      'color': _vm.customization.mainColor
    }),
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveRequest.isSuccess) ? _c('div', {
    staticClass: "success_msg"
  }, [_c('img', {
    staticClass: "success_icon",
    attrs: {
      "src": "/static/images/icons/black/success.png",
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Changes saved!")])]) : _vm._e()], 1) : _vm._e()])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b9c9bd6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9c9bd6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/notifications.vue
// module id = 809
// module chunks = 0